var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-sm-8 offset-sm-2 col-xl-6 offset-xl-3 col-12 p-0"
          },
          [
            _c(
              "div",
              {
                class: { "card py-3 shadow-sm": !_vm.$mq.phone },
                attrs: { id: "start-booking-form" }
              },
              [
                _c("div", { class: { "card-body": !_vm.$mq.phone } }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "text-center" }, [
                        _c(
                          "h3",
                          { staticClass: "booking-title mt-3" },
                          [
                            _vm.subscriptionTypeId
                              ? [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.home.subscription_service"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              : [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.getServiceParentName()) +
                                      "\n                  "
                                  )
                                ]
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-3" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.booking.new_booking.scroll_down_see_detail"
                              )
                            )
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.parentService && _vm.parentService.can_book_package
                    ? _c(
                        "section",
                        [
                          _vm.subscriptionTypeId
                            ? _c("subscription-type", {
                                attrs: {
                                  subscriptionTypeId: _vm.subscriptionTypeId
                                }
                              })
                            : _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("booking-plan", {
                                      attrs: { packageType: _vm.packageType },
                                      on: {
                                        selectPackageType: _vm.selectPackageType
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("div", { staticClass: "col-12 mt-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("h4", { staticClass: "pb-2" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.booking.booking_step.my_place")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm.filteredUserPlaces &&
                          _vm.filteredUserPlaces.length
                            ? _c("div", { staticClass: "select-jumbo mb-3" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedUserPlaceId,
                                        expression: "selectedUserPlaceId"
                                      }
                                    ],
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.selectedUserPlaceId = $event
                                            .target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                        _vm.syncUserPlaceData
                                      ]
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { domProps: { value: null } },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.booking.booking_step.please_select"
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.filteredUserPlaces, function(
                                      userPlace
                                    ) {
                                      return _c(
                                        "option",
                                        { domProps: { value: userPlace.id } },
                                        [
                                          _vm._v(
                                            _vm._s(userPlace.place_name) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "select-jumbo" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedProvinceId,
                                    expression: "selectedProvinceId"
                                  }
                                ],
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.selectedProvinceId = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    function($event) {
                                      return _vm.checkChangingCity($event)
                                    }
                                  ]
                                }
                              },
                              _vm._l(_vm.sortedCities, function(city, index) {
                                return _vm.sortedCities[index].id > 0
                                  ? _c(
                                      "option",
                                      {
                                        domProps: {
                                          value: _vm.sortedCities[index].id
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm._f("multiLangName")(city)
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              }),
                              0
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.parentServiceId === 1
                        ? [
                            _c("div", { staticClass: "col-12 mt-4" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("h4", { staticClass: "pb-2" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.booking_step.accommodation"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "select-jumbo" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selectedPlaceSize,
                                          expression: "selectedPlaceSize"
                                        }
                                      ],
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.selectedPlaceSize = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          _vm.setWorkHour
                                        ]
                                      }
                                    },
                                    _vm._l(_vm.sortedPlaceSizes, function(
                                      placeSize,
                                      index
                                    ) {
                                      return _c(
                                        "option",
                                        {
                                          domProps: {
                                            value:
                                              _vm.sortedPlaceSizes[index].id
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                _vm._f("multiLangName")(
                                                  placeSize
                                                )
                                              ) +
                                              "\n                      "
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { staticClass: "mt-2 text-primary pl-1" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.booking.booking_step.recommend"
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.globalState.durations[
                                              _vm.selectedPlaceSize
                                            ]
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "select-jumbo mt-2" },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedWorkHour,
                                            expression: "selectedWorkHour"
                                          }
                                        ],
                                        on: {
                                          change: [
                                            function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selectedWorkHour = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            },
                                            _vm.calculateCost
                                          ]
                                        }
                                      },
                                      _vm._l(
                                        _vm.globalState.workHours,
                                        function(workHour, index) {
                                          return _c(
                                            "option",
                                            { domProps: { value: index } },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(_vm.$t(workHour)) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mt-2 pl-1 text-orange" },
                                  [
                                    _vm._v(
                                      "\n                    * " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.booking.new_booking.excluding_break_time"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]
                        : _vm.parentServiceId !== 1 &&
                          _vm.parentService &&
                            _vm.parentService.child_services_text
                        ? [
                            _c("div", { staticClass: "col-12 mt-4" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("h4", { staticClass: "pb-2" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$i18n.locale === "th"
                                          ? _vm.parentService
                                              .child_services_text.title_th
                                          : _vm.parentService
                                              .child_services_text.title_en
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "select-jumbo",
                                    class: {
                                      "form-alert": _vm.errorSelectedService
                                    }
                                  },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedServiceId,
                                            expression: "selectedServiceId"
                                          }
                                        ],
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.selectedServiceId = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          { domProps: { value: null } },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.$i18n.locale === "th"
                                                    ? _vm.parentService
                                                        .child_services_text
                                                        .placeholder_th
                                                    : _vm.parentService
                                                        .child_services_text
                                                        .placeholder_en
                                                ) +
                                                "\n                      "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.childServices, function(
                                          service,
                                          index
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              domProps: {
                                                value:
                                                  _vm.childServices[index].id
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm._f("multiLangName")(
                                                      service
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.errorSelectedService
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-alert-text -status-alert"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.errorSelectedServiceText)
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.parentServiceId === 7
                    ? _c("section", [
                        _c("div", { staticClass: "row mt-3" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("h4", { staticClass: "pb-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.new_booking.choose_massage_hours"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { staticClass: "mt-2" },
                                [
                                  _c("b-form-radio-group", {
                                    staticClass: "col no-padding",
                                    attrs: {
                                      id: "btn-radios-2",
                                      options: _vm.thaiMassageOptions,
                                      buttons: "",
                                      "button-variant": "outline-info",
                                      name: "radio-btn-outline"
                                    },
                                    model: {
                                      value: _vm.selectedServiceId,
                                      callback: function($$v) {
                                        _vm.selectedServiceId = $$v
                                      },
                                      expression: "selectedServiceId"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasServiceItems
                    ? _c("section", [
                        _c("div", { staticClass: "row mt-3" }, [
                          _c("div", { staticClass: "col-12" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-start align-items-center"
                              },
                              [
                                _c("div", { staticClass: "flex-fill" }, [
                                  _c("h4", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("message.service_item.select")
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.serviceItems
                                  ? _c("div", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "text-info",
                                          attrs: { href: "" },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.clearSelectedServiceItems()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.service_item.clear"
                                                )
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "card pointer-item mb-1",
                                class: [
                                  _vm.errorServiceItems
                                    ? "border-danger"
                                    : "border-divider"
                                ],
                                on: {
                                  click: function($event) {
                                    return _vm.openServiceItemModal()
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "card-body" }, [
                                  !_vm.serviceItems
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-start align-items-center"
                                        },
                                        [
                                          _c("div", [
                                            _c("img", {
                                              attrs: {
                                                src: _vm.parentService.icon_url,
                                                width: "24"
                                              }
                                            })
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flex-fill px-3" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.service_item.select"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._m(0)
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-start align-items-top"
                                        },
                                        [
                                          _c("div", [
                                            _c("img", {
                                              staticClass: "active-svg-icon",
                                              attrs: {
                                                src: _vm.parentService.icon_url,
                                                width: "32"
                                              }
                                            })
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "flex-fill px-3" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "mb-2" },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.service_item.selected_list"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(_vm.serviceItems, function(
                                                serviceItem
                                              ) {
                                                return _c("div", [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm._f("multiLangName")(
                                                          serviceItem
                                                        )
                                                      ) +
                                                      ": " +
                                                      _vm._s(
                                                        serviceItem.count
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm._f("multiLangName")(
                                                          serviceItem.item_unit
                                                        )
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ])
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-info text-small mt-2"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.service_item.remark"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _vm._m(1)
                                        ]
                                      )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errorServiceItems
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-alert-text -status-alert"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("message.required_selection")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.user &&
                  _vm.user.flagBlack === 0 &&
                  !_vm.subscriptionTypeId
                    ? _c("div", [
                        _vm.packageType
                          ? _c("div", { staticClass: "row mt-3" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.new_booking.select_package_type"
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12" }, [
                                _c("div", { staticClass: "card shadow-sm" }, [
                                  _c("div", { staticClass: "card-body" }, [
                                    _c("div", { staticClass: "exp" }, [
                                      _c("div", { staticClass: "checkbox" }, [
                                        _c("input", {
                                          attrs: {
                                            type: "checkbox",
                                            id: "package_unlimited"
                                          },
                                          domProps: {
                                            checked:
                                              _vm.packageType &&
                                              _vm.packageType.category ===
                                                "unlimited"
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.selectPackageType(
                                                "unlimited"
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "mb-0",
                                            attrs: { for: "package_unlimited" }
                                          },
                                          [
                                            _c("span"),
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.booking.new_booking.package_type_unlimited"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "exp pt-4" }, [
                                      _c("div", { staticClass: "checkbox" }, [
                                        _c("input", {
                                          attrs: {
                                            type: "checkbox",
                                            id: "package_flexible"
                                          },
                                          domProps: {
                                            checked:
                                              _vm.packageType &&
                                              _vm.packageType.category ===
                                                "flexible"
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.selectPackageType(
                                                "flexible"
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "mb-0",
                                            attrs: { for: "package_flexible" }
                                          },
                                          [
                                            _c("span"),
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.booking.new_booking.package_type_flexible"
                                                  )
                                                ) +
                                                "\n                          "
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-inline-block text-comment text-secondary pt-1",
                                                staticStyle: {
                                                  "padding-left": "2.2rem"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.booking.new_booking.booking_type_flexible_remark"
                                                      )
                                                    ) +
                                                    "\n                          "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          : _c("div", [
                              _c("div", { staticClass: "col-12 pt-3" }, [
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.new_booking.select_booking_type"
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "card border-divider" },
                                  [
                                    _c("div", { staticClass: "card-body" }, [
                                      _c("div", { staticClass: "exp" }, [
                                        _c("div", { staticClass: "checkbox" }, [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.bookingType,
                                                expression: "bookingType"
                                              }
                                            ],
                                            attrs: {
                                              type: "radio",
                                              name: "bookingType",
                                              id: "normal_booking",
                                              value: "normal"
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.bookingType,
                                                "normal"
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.bookingType = "normal"
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "mb-0",
                                              attrs: { for: "normal_booking" }
                                            },
                                            [
                                              _c("span"),
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.booking.new_booking.booking_type_normal"
                                                    )
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "exp pt-4" }, [
                                        _c("div", { staticClass: "checkbox" }, [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.bookingType,
                                                expression: "bookingType"
                                              }
                                            ],
                                            attrs: {
                                              type: "radio",
                                              name: "bookingType",
                                              id: "flexible_booking",
                                              value: "flexible"
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.bookingType,
                                                "flexible"
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                _vm.bookingType = "flexible"
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "mb-0",
                                              attrs: { for: "flexible_booking" }
                                            },
                                            [
                                              _c("span"),
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.booking.new_booking.booking_type_flexible"
                                                    )
                                                  ) +
                                                  "\n                          "
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-inline-block text-comment text-secondary pt-1",
                                                  staticStyle: {
                                                    "padding-left": "2.2rem"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.booking.new_booking.booking_type_flexible_remark"
                                                        )
                                                      ) +
                                                      "\n                          "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    ])
                                  ]
                                )
                              ])
                            ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.packageType && _vm.packageType.category === "flexible"
                    ? _c("div", { staticClass: "row my-3" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("h4", { staticClass: "pb-2" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.booking.new_booking.how_many_package"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "select-jumbo" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.packageTypeDiscount,
                                    expression: "packageTypeDiscount"
                                  }
                                ],
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.packageTypeDiscount = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    _vm.calculateCost
                                  ]
                                }
                              },
                              _vm._l(
                                _vm.packageType.package_type_discounts,
                                function(packageTypeDiscount) {
                                  return _c(
                                    "option",
                                    {
                                      domProps: { value: packageTypeDiscount }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm._f("multiLangName")(
                                              packageTypeDiscount
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bookingType === "normal"
                    ? _c("section", [
                        !_vm.packageType ||
                        (_vm.packageType &&
                          _vm.packageType.category === "unlimited")
                          ? _c("div", { staticClass: "row pt-3" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c("h4", { staticClass: "pb-2" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.new_booking.pick_a_date"
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.packageType
                                ? _c(
                                    "div",
                                    { staticClass: "col-12 mb-4" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-remark mt-1" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.booking.new_booking.select_multi_dates"
                                                )
                                              ) +
                                              " - " +
                                              _vm._s(
                                                _vm._f("multiLangName")(
                                                  _vm.packageType
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("multi-dates-calendar", {
                                        attrs: {
                                          maxNum:
                                            _vm.packageType.num_per_package,
                                          serviceId: _vm.parentServiceId,
                                          provinceId: _vm.selectedProvinceId,
                                          sameDayBookingConfig:
                                            _vm.calendarData
                                              .sameDayBookingConfig
                                        },
                                        on: { selectDate: _vm.onDateChange }
                                      }),
                                      _vm._v(" "),
                                      _vm.multiDates &&
                                      _vm.multiDates.length > 0
                                        ? _c(
                                            "section",
                                            { staticClass: "mt-4" },
                                            [
                                              _c("package-discount", {
                                                attrs: {
                                                  numDates:
                                                    _vm.multiDates.length,
                                                  packageType: _vm.packageType
                                                }
                                              }),
                                              _vm._v(" "),
                                              _vm._l(_vm.multiDates, function(
                                                date
                                              ) {
                                                return _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-pill py-2 px-3 mr-2 mb-2 badge-light"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm._f("shortDate")(
                                                            date
                                                          )
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              })
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.errorBookingDate
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-alert-text -status-alert"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.errorBookingDateText)
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.packageType === null
                                ? _c("div", { staticClass: "col-6 pr-2" }, [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "pikadayBooking",
                                            rawName: "v-pikadayBooking",
                                            value: _vm.calendarData,
                                            expression: "calendarData"
                                          }
                                        ],
                                        ref: "cleaningDate",
                                        staticClass:
                                          "form-control -date-picker input-jumbo",
                                        class: {
                                          "form-alert": _vm.errorBookingDate
                                        },
                                        attrs: {
                                          type: "text",
                                          placeholder: _vm.$i18n.t(
                                            "message.booking.booking_step.date"
                                          ),
                                          readonly: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass:
                                          "far fa-calendar-alt input-text-icon"
                                      }),
                                      _vm._v(" "),
                                      _vm.errorBookingDate
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form-alert-text -status-alert"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.errorBookingDateText)
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  class:
                                    _vm.packageType === null
                                      ? "col-6 pl-2"
                                      : "col-12"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _vm.availableTimes &&
                                      _vm.availableTimes.length > 0
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "select-jumbo",
                                                class: {
                                                  "form-alert":
                                                    _vm.errorBookingTime
                                                }
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.selectedTime,
                                                        expression:
                                                          "selectedTime"
                                                      }
                                                    ],
                                                    staticStyle: {
                                                      background: "white"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.selectedTime = $event
                                                          .target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        domProps: {
                                                          value: null
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.booking.new_booking.time"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.availableTimes,
                                                      function(time) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value: time
                                                            }
                                                          },
                                                          [_vm._v(_vm._s(time))]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass:
                                                    "far fa-clock input-text-icon"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.errorBookingTime
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-alert-text -status-alert"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.required_selection"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-orange pt-2"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.alert.sold_out"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                    ],
                                    2
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.parentServiceId === 7
                          ? _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12 text-remark" }, [
                                _vm.availableService.available_number > 0
                                  ? _c("div", { staticClass: "text-success" }, [
                                      _c("i", {
                                        staticClass: "fas fa-user mr-1"
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.booking.new_booking.left_number",
                                              {
                                                num:
                                                  _vm.availableService
                                                    .available_number
                                              }
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  : _c("div", { staticClass: "text-orange" }, [
                                      _c("i", {
                                        staticClass: "fas fa-user mr-1"
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "message.alert.no_available_service"
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ])
                              ])
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-3" }, [
                    _c("div", { staticClass: "col-8" }, [
                      _c("label", { staticClass: "text-dark" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t("message.booking.new_booking.subtotal")
                            ) +
                            "\n              "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-4 text-right" }, [
                      _c("h3", { staticClass: "text-primary" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm._f("currency")(_vm.subtotal)) +
                            "\n              "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-3" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-lg btn-info btn-block -cyan",
                          attrs: { disabled: _vm.checkDisabledButton },
                          on: { click: _vm.goToCheckout }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("message.booking.new_booking.continue")
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.$mq.phone ? _c("hr", { staticClass: "mx-3 my-4" }) : _vm._e(),
      _vm._v(" "),
      Number(this.$route.query.subscriptionTypeId) === 1
        ? _c("subscription-detail-modal", { ref: "subscriptionDetailModal" })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasServiceItems
        ? _c("service-item-modal", {
            ref: "serviceItemModal",
            attrs: { parentService: _vm.parentService },
            on: { selectServiceItems: _vm.setServiceItems }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "fal fa-plus-circle text-info fa-lg" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("button", { staticClass: "btn btn-outline-info rounded-pill" }, [
        _vm._v("แก้ไข")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_c("hr")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-111f5b17", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-111f5b17","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/newSteps/Booking.vue
// module id = 1708
// module chunks = 0